import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

const Wrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  padding: theme.spacing(6, 3),
  minHeight: 360,
  width: "100%",
  gap: theme.spacing(1.5),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const EmptyIcon = styled(Box)(({ theme }) => ({
  width: 88,
  height: 88,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.grey[50],
  border: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.tertiary,
}));

const GlobalEmptyPage = ({ image, title = "No data found", description = "There is nothing to show here yet.", action }) => {
  return (
    <Wrapper>
      {image ? (
        <Box
          component="img"
          src={image}
          alt=""
          sx={{
            width: "min(260px, 70vw)",
            height: "auto",
            maxHeight: 180,
            objectFit: "contain",
            mb: 1,
          }}
        />
      ) : (
        <EmptyIcon>
          <InboxOutlinedIcon sx={{ fontSize: 42 }} />
        </EmptyIcon>
      )}
      <Typography variant="h6" color="text.primary" sx={{ mt: image ? 1 : 0 }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 460 }}>
        {description}
      </Typography>
      {action && <Box sx={{ mt: 1 }}>{action}</Box>}
    </Wrapper>
  );
};

export default GlobalEmptyPage;
